import { Chip } from '@mui/material';
import { Clear } from '@mui/icons-material';
import type { ActiveFilter } from './useActiveFilters';

export interface FilterChipProps {
    filter: ActiveFilter;
    onRemove: (filterId: string) => void;
}

/**
 * FilterChip renders a single filter chip.
 * Permanent filters are displayed as filled chips without delete button.
 * Removable filters are displayed as outlined chips with a delete button.
 */
const FilterChip = ({ filter, onRemove }: FilterChipProps) => {
    if (filter.isPermanent) {
        return <Chip key={filter.id} label={String(filter?.displayLabel)} size="small" variant="filled" color="default" />;
    }

    return (
        <Chip
            key={filter.id}
            label={String(filter.displayLabel)}
            size="small"
            variant="outlined"
            onClick={() => onRemove(filter.id)}
            onDelete={() => onRemove(filter.id)}
            deleteIcon={<Clear />}
        />
    );
};

export default FilterChip;
